import type { ReactNode } from 'react';

export const symbol_align_flex_end: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm350-170q-12.75 0-21.37-8.63Q430-267.25 430-280v-510q0-12.75 8.63-21.38Q447.25-820 460-820h40q12.75 0 21.38 8.62Q530-802.75 530-790v510q0 12.75-8.62 21.37Q512.75-250 500-250h-40Z"
		/>
	</svg>
);
